import { Helmet } from 'react-helmet'
import FloatingWhatsApp from '../../../interface/floating_whatsapp/FloatingWhatsApp'
import Footer from '../../Footer'
import Testimonials from '../../Testimonials'
import './AppRekanata.css'
import HeroBackground from './pages/hero_background/HeroBackground'
import OurService from './pages/OurService'
import SEO from '../../../SEO/SEO'
import OurLocation from '../../../ourlocation/OurLocation'

function AppRekanata() {
    return (
        <div className='app-rekanata-section fade' id='id-app-rekanata-section'>
            <SEO
                title="Tentang Kami - Rekanata Konstruksi"
                description="Rekanata adalah jasa kontraktor profesional yang siap melayani Anda di seluruh Indonesia."
                canonical="https://rekanata.com/about-rekanata"
            // Tidak perlu menambahkan metaKeywords di sini. Jika tidak diisi, fallback default akan digunakan. 
            // Jika Anda mengisi nilai di sini, maka nilai yang dituliskan di properti ini yang akan digunakan.
            />

            <HeroBackground />

            <OurLocation/>

            <OurService />

            {/**
             <About/>
            <OurService/>
            <Testimonials/>
             */}

            <FloatingWhatsApp />
            <Footer />
        </div>
    )
}

export default AppRekanata